import creditcardutils from 'creditcardutils';
import { isPast, isSameMonth, isValid, parse } from 'date-fns';

export const isCardNumberValid = (cardNumber: string) => {
  return cardNumber && creditcardutils.validateCardNumber(cardNumber);
};

export const isCardExpiryValid = (dateValue: string) => {
  if (!dateValue) {
    return false;
  }
  const parsedDate = parse(dateValue, 'MM/yy', new Date());
  const isCurrentMonth = isSameMonth(parsedDate, new Date());
  return (!isPast(parsedDate) || isCurrentMonth) && isValid(parsedDate);
};

export const isCardExpired = (dateValue: string) => {
  if (!dateValue) {
    return false;
  }
  const parsedDate = parse(dateValue, 'MM/yy', new Date());
  return isPast(parsedDate) && !isSameMonth(parsedDate, new Date());
};

export const isCardCvcValid = (cvc: string, length: 3 | 4) => {
  if (!cvc || !Number.isFinite(Number(cvc))) {
    return false;
  }
  return cvc.length === length;
};
